'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.INVALID_FORM_REPORT_MODAL = exports.CHANGE_EMAIL_REPORT_MODAL = exports.CHANGE_TEXT_REPORT_MODAL = exports.SEND_REPORT_MODAL = exports.OPEN_REPORT_MODAL = exports.CLOSE_REPORT_MODAL = undefined;

var _doctifyUtils = require('doctify-utils');

var CLOSE_REPORT_MODAL = exports.CLOSE_REPORT_MODAL = 'REPORT_MODAL:CLOSE_REPORT_MODAL';

var OPEN_REPORT_MODAL = exports.OPEN_REPORT_MODAL = 'REPORT_MODAL:OPEN_REPORT_MODAL';
var SEND_REPORT_MODAL = exports.SEND_REPORT_MODAL = 'REPORT_MODAL:SEND_REPORT';
var CHANGE_TEXT_REPORT_MODAL = exports.CHANGE_TEXT_REPORT_MODAL = 'REPORT_MODAL:CHANGE_TEXT';
var CHANGE_EMAIL_REPORT_MODAL = exports.CHANGE_EMAIL_REPORT_MODAL = 'REPORT_MODAL:CHANGE_EMAIL';
var INVALID_FORM_REPORT_MODAL = exports.INVALID_FORM_REPORT_MODAL = 'REPORT_MODAL:INVALID_FORM';

var ReportModalActions = {
    closeReportModal: function closeReportModal() {
        return {
            type: CLOSE_REPORT_MODAL
        };
    },
    openReportModal: function openReportModal(model) {
        return {
            type: OPEN_REPORT_MODAL,
            payload: model
        };
    },
    sendReportModal: function sendReportModal(url, data) {
        return (0, _doctifyUtils.createAction)({
            actionType: SEND_REPORT_MODAL,
            url: url,
            method: 'POST',
            data: data
        });
    },
    changeReportModalText: function changeReportModalText(text) {
        return {
            type: CHANGE_TEXT_REPORT_MODAL,
            payload: {
                reportText: text
            }
        };
    },
    changeReportModalEmail: function changeReportModalEmail(email) {
        return {
            type: CHANGE_EMAIL_REPORT_MODAL,
            payload: {
                reportEmail: email
            }
        };
    },
    invalidateReportModal: function invalidateReportModal() {
        return {
            type: INVALID_FORM_REPORT_MODAL
        };
    }
};

exports.default = ReportModalActions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/actions/report-modal.js
// module id = 655
// module chunks = 0